import Vue from 'vue';
import buefy from 'buefy';
import App from './App.vue';
import '@elo/icons';
import UI from '@elo/ui';
import Components from '@elo/components';
import '@elo/ui/dist/elo-ui.css';
import '@elo/font-elo-sans-pro';
import './jsLocales/all_locales';
import ReactiveProvide from 'vue-reactive-provide';

Vue.use(UI);
Vue.use(buefy);
Vue.use(Components);
Vue.use(ReactiveProvide);

Vue.config.productionTip = false;

// EVV-20: Sprache ermitteln, anhand der Browsersprache
let lang = navigator.language;

// magic number
// eslint-disable-next-line
lang = lang.substring(0, 2);
// Fallback falls Sprache nicht vorhanden ist.
if (!window.elo.locale.localeMap[lang]) {
  lang = 'en';
}
// Setzen der Sprache
window.elo.data.server.language = lang;
window.elo.locale.language = lang;
window.elo.locale.store = window.elo.locale.localeMap[lang];

new Vue({render: (h) => h(App)}).$mount('#app');
